const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { autoScrollLeft, autoScrollRight } = require('./modules/tab');

scrollmagic();
pageTop();
smooth();
autoScrollLeft();
autoScrollRight();